import type { BridgeMethod } from '@kherel/app-bridge';

export interface BridgeRequest {
  type: 'bridge';
  method: BridgeMethod;
  callId: string;
  params?: unknown;
}

export interface BridgeResponse {
  type: 'bridge';
  callId: string;
  result?: unknown;
  error?: {
    code: string;
    message: string;
  };
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export function isBridgeRequest(value: unknown): value is BridgeRequest {
  return (
    isRecord(value) &&
    value.type === 'bridge' &&
    typeof value.callId === 'string' &&
    value.callId.length > 0 &&
    typeof value.method === 'string' &&
    value.method.startsWith('TribeApp')
  );
}

export const CAPABILITIES: ReadonlyArray<{
  method: BridgeMethod;
  title: string;
  group: 'session' | 'discovery' | 'navigation' | 'commerce';
}> = [
  { method: 'TribeAppInit', title: 'Initialize', group: 'session' },
  {
    method: 'TribeAppGetLaunchParams',
    title: 'Launch parameters',
    group: 'session',
  },
  {
    method: 'TribeAppGetUserInfo',
    title: 'User information',
    group: 'session',
  },
  {
    method: 'TribeAppSearchUsers',
    title: 'Search users',
    group: 'discovery',
  },
  {
    method: 'TribeAppCallBackend',
    title: 'Host backend proxy',
    group: 'discovery',
  },
  {
    method: 'TribeAppRequestScopes',
    title: 'Request scopes',
    group: 'discovery',
  },
  {
    method: 'TribeAppOpenProfile',
    title: 'Open profile',
    group: 'navigation',
  },
  {
    method: 'TribeAppOpenDirectMessage',
    title: 'Open direct message',
    group: 'navigation',
  },
  {
    method: 'TribeAppOpenLink',
    title: 'Open external link',
    group: 'navigation',
  },
  {
    method: 'TribeAppShowAlert',
    title: 'Host alert',
    group: 'navigation',
  },
  {
    method: 'TribeAppShowConfirm',
    title: 'Host confirmation',
    group: 'navigation',
  },
  {
    method: 'TribeAppResize',
    title: 'Resize iframe',
    group: 'navigation',
  },
  { method: 'TribeAppClose', title: 'Close app', group: 'navigation' },
  {
    method: 'TribeAppGetBilling',
    title: 'Billing snapshot',
    group: 'commerce',
  },
  {
    method: 'TribeAppRequestPurchase',
    title: 'Purchase flow',
    group: 'commerce',
  },
  {
    method: 'TribeAppTrackEvent',
    title: 'Analytics event',
    group: 'commerce',
  },
];
